import React, { Component } from 'react';
import PropTypes from 'prop-types';
import url from 'url';
import {
  checkAndReportMissingAparmentLocatorFields,
} from 'common/apartmentLocatorHelpers';
import {
  getListingUrlPath,
} from 'common/listingHelpers';
import firstWordCapitalized from 'common/util/firstWordCapitalized';
import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

class SrListingApartmentLocatorSection extends Component {
  static propTypes = {
    apartmentLocator: PropTypes.object.isRequired,
    listing: PropTypes.object,
    isDefault: PropTypes.bool.isRequired,
    appUrl: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  };

  componentDidMount() {
    checkAndReportMissingAparmentLocatorFields(this.props.apartmentLocator);
  }

  _onSoundsGoodButtonClick = () => {
    const { history, listing, appUrl } = this.props;

    const listingToBookmark = url.resolve(appUrl, getListingUrlPath(listing, {
      addBookmark: true,
    }));

    history.push(listingToBookmark);
  }

  render() {
    const {
      apartmentLocator,
      isDefault,
    } = this.props;

    const apartmentLocatorFirstName = firstWordCapitalized(apartmentLocator.name);

    return (
      <div className='section apartmentLocatorSection'>
        <SrBox
          margin='0 auto'
        >
          <div id='mainHeadingRow'>
            <SrText
              size='26'
              weight='600'
              lineHeight='35px'
              align='center'
              display='block'
            >
              Apartment Info Requested!
            </SrText>
          </div>
          <SrText
            size='26'
            weight='600'
            lineHeight='35px'
            align='center'
            display='block'
          >
            Here's what happens next:
          </SrText>
        </SrBox>
        {isDefault ? (
          <div className='apartmentLocatorAssignment'>
            <div>
              <span>
                You were just assigned to a
              </span>
            </div>
            <div>
              <span role='img' aria-label='check'>
                Sunroom certified locator! ✅
              </span>
            </div>
          </div>
        ) : (
          <div className='apartmentLocatorAssignment'>
            <div>
              <span>
                You were just assigned to {apartmentLocatorFirstName},
              </span>
            </div>
            <div>
              <span role='img' aria-label='check'>
                a certified locator! ✅
              </span>
            </div>
          </div>
        )}
        <SrBox marginTop='50px'>
          <div className='step'>
            <span className='headline'>
              {
                'Talk with ' +
                `${isDefault ? 'an expert' : apartmentLocatorFirstName}`
              }
            </span>
            <span className='bodyText'>
              {
                `${isDefault ? 'You have an' : 'They\'re your'} ` +
                'assigned Sunroom apartment locator! They\'ll text you soon.'
              }
            </span>
          </div>

          <div className='step'>
            <span className='headline'>Get a list of apartments</span>
            <span className='bodyText'>
              {
                `${isDefault ? 'Your locator' : apartmentLocatorFirstName} will ` +
                'call apartments and check for availability and pricing for you!'
              }
            </span>
          </div>

          <div className='step'>
            <span className='headline'>Go see your favorites</span>
            <span className='bodyText'>
              {
                `Meet ${isDefault ? 'your locator' : apartmentLocatorFirstName} ` +
                'at the apartments when you’re ready.'
              }
            </span>
          </div>
        </SrBox>

        <div className='imageContainer'>
          <img src='/images/illustration-cloud-sun.svg' alt='illustration-cloud-sun' />
        </div>

        <div className='valuePropSectionTitle'>
          <div>
            <span role='img' aria-label='heart'>
              Why renters ❤️
            </span>
          </div>
          <div>
            <span>
              Sunroom locators
            </span>
          </div>
        </div>

        <div className='valuePropHeader'>
          <span>
            Knowledgeable Experts
          </span>
        </div>
        <div className='valuePropContent'>
          <span>
            {
              'Sunroom Locators are locals, and have helped thousands of renters move! '
            }
            <span className='valuePropEmphasis'>
              We’ll find you the perfect place with the best deal.
            </span>
          </span>
        </div>
        <div className='valuePropHeader'>
          <span>
            Insider Info
          </span>
        </div>
        <div className='valuePropContent'>
          <span>
            <span className='valuePropEmphasis'>
              We have a database of every apartment.
            </span>
            {
              ' Sunroom has access to unadvertised specials, apartment qualification information' +
              ', unit availability, and pricing.'
            }
          </span>
        </div>
        <div className='valuePropHeader'>
          <span>
            Totally Free!
          </span>
        </div>
        <div className='valuePropContent'>
          <span>
            {
              'Sunroom is free because we get paid by the apartments. ' +
              'All we ask is that you '
            }
            <span className='valuePropEmphasis'>
              write your locator’s name on your apartment application,
            </span>
            {
              ' so we can get credit for helping.'
            }
          </span>
        </div>

        <ButtonDeprecated
          className='yellow'
          onClick={this._onSoundsGoodButtonClick}
        >
          ok, sounds good!
        </ButtonDeprecated>
      </div>
    );
  }
}

SrListingApartmentLocatorSection.displayName = 'SrListingApartmentLocatorSection';

export default SrListingApartmentLocatorSection;
